<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 13.5156C5 13.127 4.68555 12.8125 4.29688 12.8125H1.95312C1.56445 12.8125 1.25 13.127 1.25 13.5156C1.25 13.9043 1.56445 14.2188 1.95312 14.2188H4.29688C4.68555 14.2188 5 13.9043 5 13.5156ZM1.95312 7.22656H4.29688C4.68555 7.22656 5 6.91211 5 6.52344C5 6.13477 4.68555 5.82031 4.29688 5.82031H1.95312C1.56445 5.82031 1.25 6.13477 1.25 6.52344C1.25 6.91211 1.56445 7.22656 1.95312 7.22656Z"
      fill="currentColor"
    />
    <path
      d="M17.3438 1.25H3.90625C3.12891 1.25 2.5 1.87891 2.5 2.65625V3.75C2.5 4.13867 2.81445 4.45312 3.20312 4.45312C3.5918 4.45312 3.90625 4.13867 3.90625 3.75V2.65625H17.3438V17.3438H3.90625V16.2891H3.9043C3.9043 16.2754 3.90625 16.2637 3.90625 16.25C3.90625 15.8613 3.5918 15.5469 3.20312 15.5469C2.81445 15.5469 2.5 15.8613 2.5 16.25C2.5 16.2637 2.5 16.2754 2.50195 16.2891H2.5V17.3438C2.5 18.1211 3.12891 18.75 3.90625 18.75H17.3438C18.1211 18.75 18.75 18.1211 18.75 17.3438V2.65625C18.75 1.87891 18.1211 1.25 17.3438 1.25Z"
      fill="currentColor"
    />
    <path
      d="M1.95312 10.7227H4.29688C4.68555 10.7227 5 10.4082 5 10.0195C5 9.63086 4.68555 9.31641 4.29688 9.31641H1.95312C1.56445 9.31641 1.25 9.63086 1.25 10.0195C1.25 10.4082 1.56445 10.7227 1.95312 10.7227ZM11.2422 11.4062C9.47656 11.4062 8.03906 9.96875 8.03906 8.20312C8.03906 6.4375 9.47656 5 11.2422 5C13.0078 5 14.4453 6.4375 14.4453 8.20312C14.4453 9.96875 13.0078 11.4062 11.2422 11.4062ZM11.2422 6.40625C10.252 6.40625 9.44531 7.21289 9.44531 8.20312C9.44531 9.19336 10.252 10 11.2422 10C12.2324 10 13.0391 9.19336 13.0391 8.20312C13.0391 7.21289 12.2324 6.40625 11.2422 6.40625Z"
      fill="currentColor"
    />
    <path
      d="M14.9257 15C14.5937 15 14.2987 14.7656 14.2362 14.4277C13.9628 12.9941 12.705 11.9531 11.2421 11.9531C9.77921 11.9531 8.5214 12.9941 8.24796 14.4277C8.18351 14.7656 7.88859 15 7.55851 15C7.51554 15 7.47062 14.9961 7.42765 14.9883C7.04679 14.916 6.79484 14.5488 6.8671 14.166C7.26359 12.0684 9.10343 10.5469 11.2421 10.5469C13.3788 10.5469 15.2206 12.0684 15.6171 14.166C15.6894 14.5469 15.4394 14.916 15.0566 14.9883C15.0136 14.9961 14.9687 15 14.9257 15Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Contacts',
} as DefineComponent
</script>
